<script>
  /**
  * Browser test fail explanation and solution
  */

  export default {
    name: 'TestFail',
    data () {
      return {
        'testName': null
      }
    },

    props: {

      skipOption: {
        'type': Boolean,
        'default': false
      },

      usersBrowserName: {
        'type': String,
        'default': null
      },

      usersBrowserVersion: {
        'type': Number,
        'default': false
      },

      usersOperatingSystem: {
        'type': String,
        'default': null
      },

      usersPlatform: {
        'type': String,
        'default': null
      }

    },

    methods: {
      skipTest () {
        this.$emit('skipTest', this.testName)
      }
    },

    computed: {
      iOSDevice () {
        return this.usersOperatingSystem && this.usersOperatingSystem.includes('iOS')
      }
    }


  }
</script>

<style scoped lang="less">

  .browser-name {
    text-transform: capitalize;
  }

</style>

<docs></docs>

